import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

export interface InventarioContext {
  idInventario: string | null;
  latitude: number | null;
  longitude: number | null;
}

const STORAGE_KEY = "inventario_context";
@Injectable({providedIn: "root"})
export class InventarioContextService {
  private contextSubject = new BehaviorSubject<InventarioContext>(
    this.loadFromStorage()
  );

  context$ = this.contextSubject.asObservable();

  /* ========================
     SETTERS
  ======================== */

  setContext(context: InventarioContext): void {
    this.updateContext(context);
  }

  setIdInventario(idInventario: string): void {
    this.updateContext({
      ...this.contextSubject.value,
      idInventario,
    });
  }

  setLocalizacao(latitude: number, longitude: number): void {
    this.updateContext({
      ...this.contextSubject.value,
      latitude,
      longitude,
    });
  }

  /* ========================
     GETTERS (snapshot)
  ======================== */

  getContext(): InventarioContext {
    return this.contextSubject.value;
  }

  getIdInventario(): string | null {
    return this.contextSubject.value.idInventario;
  }

  getLatitude(): number | null {
    return this.contextSubject.value.latitude;
  }

  getLongitude(): number | null {
    return this.contextSubject.value.longitude;
  }

  /* ========================
     LOCAL STORAGE
  ======================== */

  private updateContext(context: InventarioContext): void {
    this.contextSubject.next(context);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  }

  private loadFromStorage(): InventarioContext {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored
      ? JSON.parse(stored)
      : {
          idInventario: null,
          latitude: null,
          longitude: null,
        };
  }

  clear(): void {
    localStorage.removeItem(STORAGE_KEY);
    this.contextSubject.next({
      idInventario: null,
      latitude: null,
      longitude: null,
    });
  }
}
